<template>
 <div>
  <v-dialog v-model="hideShow" max-width="560" persistent scrollable content-class="student-join-dialog">
   <v-card class="fc-dialog-card student-operation-dialog">
    <v-card-title class="fc-dialog-header">
     <span class="fc-dialog-symbol" aria-hidden="true"><v-icon color="#d9363e" size="22">mdi-account-multiple-plus-outline</v-icon></span>
     <div><h2>给学员分班</h2><p>选择课程、班级并确认进班日期</p></div>
     <v-spacer /><v-btn icon aria-label="关闭学员分班" @click="cancel"><v-icon size="21">mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="fc-dialog-body">
     <div v-if="student" class="student-operation-context"><span class="student-operation-avatar" aria-hidden="true"><v-icon size="22" color="#61748a">mdi-account-outline</v-icon></span><div><span>当前学员</span><strong>{{ student.studentName || '—' }}</strong></div></div>
     <v-form class="student-operation-form" @submit.prevent="submit">
      <v-select v-model="add.courseModel" :items="selectCourseList" label="课程" item-text="courseName" item-value="id" return-object outlined dense hide-details color="#d9363e" @change="courseChanged" />
      <v-autocomplete v-model="add.classModel" :items="selectClassList" label="班级" item-text="className" item-value="id" return-object outlined dense hide-details color="#d9363e" no-data-text="该课程下无开设的班级" />
      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
       <template v-slot:activator="{ on, attrs }"><v-text-field v-model="add.joinDate" label="进班日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" append-icon="mdi-calendar-outline" /></template>
       <v-date-picker v-model="add.joinDate" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" />
      </v-menu>
      <v-text-field v-if="add.courseModel && add.courseModel.consumeType=='2'" v-model="add.consumePrice" label="每课时扣费金额" suffix="元 / 课时" dense outlined hide-details color="#d9363e" />
     </v-form>
     <p class="student-operation-hint">先选择课程，再选择该课程下的班级。</p>
    </v-card-text>
    <v-card-actions class="fc-dialog-actions"><v-spacer /><v-btn text @click="cancel">取消</v-btn><v-btn color="#d9363e" depressed class="fc-confirm" :loading="add.submitting" @click="submit">确认分班</v-btn></v-card-actions>
   </v-card>
  </v-dialog>
 </div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"create-student",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			student:{
				type:Object,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					
					this.clearAdd();
					
					
					this.getCourseListForSelect();
				}
			}
		},
		data(){
			return {
				menu1:false,
				add: {
					submitting:false,
					courseModel:null,
					classModel:null,
					consumePrice:"",
					joinDate:"",
				},
				selectCourseList:[],
				selectClassList:[],
				hideShow:this.show
			}
		},
		mounted() {
			console.log("student-join-class mounted");
		},
		methods:{
			clearAdd(){
				this.selectCourseList = [];
				this.selectClassList = [];
				this.add.courseModel = null;
				this.add.classModel=null;
				this.add.consumePrice = "";
				this.add.joinDate = utils.getNowDate();
			},
			submit(){
				console.log("提交");
				
				if (!this.add.courseModel) {
					this.$noty.error('请选择课程');
					return
				}
				if (!this.add.classModel) {
					this.$noty.error('请选择要加入的班级');
					return
				}
				
				if (this.add.courseModel.consumeType==='2'){
					if(!this.add.consumePrice){
						this.$noty.error('课时单价不能为空');
						return
					}
				}
				
				this.add.submitting = true;	
				// api
				const that = this;
				let url = `/edu/class/student/create`;
				let postData = {
					shopId:this.student.shopId,
					classId:this.add.classModel.id,
					studentId: this.student.id,
					consumePrice:this.add.consumePrice,
					joinDate:this.add.joinDate,
				};
				
				//console.log("joinData:",postData);
				
				this.axios.post(url, postData).catch(() => {
					that.add.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("添加成功");
							that.add.submitting = false;
							this.$emit("success","");
							return;
						} else {
							that.add.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			},
			cancel(){
				this.$emit("cancel","");
			},
			courseChanged(e){
				const courseId = e.id;
				
				this.add.consumePrice = e.consumePrice;
				
				//获取班级
				this.getClassListForSelect(courseId);
				
			},
			getCourseListForSelect() {
				// 获取课程
				const shopId = this.student.shopId;
				
				if (!shopId) {
					return
				}
			
				const that = this;
				let url = `/edu/shop/course/list/` + shopId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						let cList = response.data["data"] ? response.data["data"] : [];
						that.selectCourseList = cList.filter(item=>item.status == "1");
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassListForSelect(courseId) {
			
				if (!courseId) {
					return
				}
			
				const that = this;
				let url = `/edu/course/all/class/list/` + courseId;
			
				this.axios.get(url).then(response => {
			
					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}
			
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
	
</script>

<style lang="scss" scoped>
@import "../assets/styles/student-operation-dialog";
</style>
